/**
 * @author       Digitsensitive <digit.sensitivee@gmail.com>
 * @copyright    2018 Digitsensitive
 * @description  Coin Runner: Player
 * @license      Digitsensitive
 */

export class Player extends Phaser.GameObjects.Image {
    private cursors: any;
    private walkingSpeed: number = 5;

    constructor(params) {
        super(params.scene, params.x, params.y, params.key);

        this.initImage();
        this.initInput(params);
        params.scene.add.existing(this);
    }

    private initImage(): void {
        this.setDisplaySize(40, 50);
        this.setOrigin(0.5, 0.5);
    }
    private initInput(params): void {
        // this.cursors = (params.scene as Phaser.Scene).input.keyboard.createCursorKeys();
        this.cursors = params.keyboard;
    }

    update(): void {
        this.handleInput();
    }

    private handleInput(): void {
        if (this.cursors == null) {
            return;
        }
        if (this.cursors.right.isDown) {
            this.x += this.walkingSpeed;
            this.setFlipX(false);
        }
        if (this.cursors.left.isDown) {
            this.x -= this.walkingSpeed;
            this.setFlipX(true);
        }
        if (this.cursors.up.isDown) {
            this.y -= this.walkingSpeed;
        }
        if (this.cursors.down.isDown) {
            this.y += this.walkingSpeed;
        }
    }
}



// WEBPACK FOOTER //
// ./src/games/demos/phaserDemo/objects/player.ts